import React from 'react'
import { NewAppLayout } from '@/components/new-ux/layout/NewAppLayout'
import { CampaignLaunchNotificationTest } from "@/components/testing/CampaignLaunchNotificationTest"

export default function CampaignNotificationTestPage() {
  return (
    <NewAppLayout>
      <div className="max-w-4xl mx-auto">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-900">Campaign Launch Notification Test</h1>
          <p className="text-gray-600 mt-2">
            Test the Slack notification system for campaign launches. This will send notifications to both client channels and the master campaigns channel.
          </p>
        </div>
        <CampaignLaunchNotificationTest />
      </div>
    </NewAppLayout>
  )
}
